import DBR from 'dynamsoft-javascript-barcode'
DBR.BarcodeReader.engineResourcePath = 'https://cdn.jsdelivr.net/npm/dynamsoft-javascript-barcode@8.1.3/dist/'
// Please visit https://www.dynamsoft.com/customer/license/trialLicense to get a trial license
DBR.BarcodeReader.handshakeCode = '100195341-100454833'
// DBR.BarcodeReader._bUseFullFeature = true; // Control of loading min wasm or full wasm.
export default DBR
console.log('>>>05/12/2021_1<<<')



// WEBPACK FOOTER //
// ./src/components/Dashboard/Views/Utils/dynamo/dbr.js